import { ReactComponent as WarnSvg } from '@/images/icons/alert/warn.svg';
export default WarnSvg;
